import React, { useState } from "react";
import { Accordion, TextLink, Separator } from "glic-ui-components";
import "./index.scss";
import { Form } from "../../../../components/Form";
import { ValidationErrorMessage } from "../../../../components/ValidationErrorMessage";
import { FormFields } from "./formFields";
import { COMMON_CONSTANTS } from "../../../../utils/Constants/CommonConstants.js";
import { has, get } from "lodash";
import { MESSAGES } from "../../../../utils/Constants";

const TermsAndConditionsComponent = ({
  setCheckBoxValues: setCheckBoxValuesInUpstream,
  openTermsAndConditionAccordian,
}) => {
  const [checkBoxValues, setCheckBoxValues] = useState({});
  const [isShowTermsAndConditionContents, showTermsAndConditionContents] =
    useState(false);
  const onChangeField = (e, isCheckboxActive) => {
    console.log("e>>>>>", e.target.name);
    setCheckBoxValues({
      ...checkBoxValues,
      [e.target.name]: { id: e.target.name, isCheckboxActive },
    });
    console.log("checkBoxValues>>> i am in child", checkBoxValues);
    setCheckBoxValuesInUpstream({
      ...checkBoxValues,
      [e.target.name]: { id: e.target.name, isCheckboxActive },
    });
  };
  console.log("checkBoxValues>>>>>>meeee", checkBoxValues);

  const validatorComponent = {
    [get(FormFields, "Privacy_Statement_Checkbox.id")]: !has(
      checkBoxValues,
      get(FormFields, "Privacy_Statement_Checkbox.name")
    ) ? (
      <ValidationErrorMessage
        message={MESSAGES.TERMS_AND_CONDITION_VALIDATION_MESSAGE}
        id={"privacy-statement-error"}
      />
    ) : null,
    [get(FormFields, "Arbitration_Clause_Checkbox.id")]: !has(
      checkBoxValues,
      get(FormFields, "Arbitration_Clause_Checkbox.name")
    ) ? (
      <ValidationErrorMessage
        message={MESSAGES.TERMS_AND_CONDITION_VALIDATION_MESSAGE}
        id={"arbitration-clause-error"}
      />
    ) : null,
  };
  return (
    <div className="terms-condition-container">
      <Separator />
      <div className="flex">
        <div className="flex-1 margin-top-1-rem">
          You must agree to the following terms and condition to use our site
        </div>
      </div>
      <Accordion
        onCollapse={() => showTermsAndConditionContents(false)}
        onExpand={() => showTermsAndConditionContents(true)}
      >
        <Accordion.Item
          uid="accordion-item-1"
          title="Terms and Conditions"
          headingLevel="h2"
          expanded={openTermsAndConditionAccordian}
        >
          {isShowTermsAndConditionContents ? (
            <div className="flex">
              <div className="flex-1 margin-top-1-rem">
                <TextLink
                  isExternal
                  to={
                    COMMON_CONSTANTS.GA_TERMS_CONDITION_LINKS
                      .GUARDIAN_ONLINE_TERMS_AND_CONDITION
                  }
                >
                  Guardian's Online Terms and Conditions of Use
                </TextLink>
              </div>
              <div className="flex-1 margin-top-1-rem">
                <TextLink
                  isExternal
                  to={COMMON_CONSTANTS.GA_TERMS_CONDITION_LINKS.PRIVACY_POLICY}
                >
                  Privacy Policy
                </TextLink>
              </div>
              <div className="flex-1 margin-top-1-rem">
                <TextLink
                  isExternal
                  to={
                    COMMON_CONSTANTS.GA_TERMS_CONDITION_LINKS
                      .AGREEMENT_TO_CONDUCT_BUSINESS
                  }
                >
                  Agreement to conduct business electronically
                </TextLink>
              </div>
              <div className="flex-1 margin-top-1-rem">
                <Form
                  fields={FormFields}
                  onChange={onChangeField}
                  onBlur={(e) => console.log(e)}
                  validatorComponent={validatorComponent}
                />
              </div>
            </div>
          ) : null}
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export const TermsAndConditions = TermsAndConditionsComponent;
